import { CreateBookingResponse } from '@/dto/api/create-booking.dto'
import { Prescription, PrescriptionAlreadyExists, PrescriptionGetOrUpdate } from '@/dto/api/prescription.dto'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL ?? 'https://dev.ludafarma.com:8443/public-api/prescription'
const API_TOKEN_KEY = 'x-auth-token'
const API_TOKEN_VALUE = process.env.REACT_APP_API_TOKEN ?? 'd54289f86319dd4035734f142f9308e7'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    [API_TOKEN_KEY]: API_TOKEN_VALUE
  }
})

export async function getPrescriptionById (body: PrescriptionGetOrUpdate): Promise<Prescription | PrescriptionAlreadyExists> {
  const maxLimit = 10

  const { data } = await api.post<Prescription>('/process', {
    ...body,
    maxLimit
  })

  return data
}

export async function createBooking (prescriptionId: string, pharmacyId: string): Promise<CreateBookingResponse> {
  const { data: { bookingId } } = await api.post('/createBookingOnPharmacy', {
    prescriptionId,
    pharmacyId
  })

  return { bookingId }
}
